import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Paper, makeStyles, FormControlLabel, Checkbox, LinearProgress } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { genColHeaderName } from 'utils/functions';
import { handleError } from 'reducers/ErrorReducer';
import { getService } from 'reducers/service';

const useStyles = makeStyles((theme) => ({
  error: {
    marginBottom: 16,
  },
  stats: {
    '& td': {
      fontSize: 16,
      paddingRight: 16,
    },
  },
  personDetails: {
    display: 'inline-block',
    padding: '8px 16px',
    fontSize: 20,
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 16,
    '& span': {
      display: 'inline-block',
      color: theme.palette.secondary.main,
      marginRight: 8,
    },
  },
  loading: {
    paddingTop: 12,
    marginTop: -16,
    marginBottom: 16,
    width: '100%',
    height: 16,
  },
}));

function Review(props) {
  const {
    source,
    target,
    data,
    setLoading,
    personData,
    setPersonData,
    deleteSource,
    setDeleteSource,
    loading,
  } = props;
  const mountedRef = useRef(true);
  const classes = useStyles();

  const [noFirstName, setNoFirstName] = useState(null);
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    processTargetData();
    checkStats();

    return () => {
      mountedRef.current = false;
    };
  }, []);

  const processTargetData = () => {
    const newData = { ...target };
    data.forEach((i) => {
      const key = i.field;
      const val = i.isTargetVal ? i.targetVal : i.sourceVal;
      newData[key] = val;
    });

    const FirstName = newData.FirstName;
    if (FirstName === null) setNoFirstName(true);

    const FullName = `${newData.FirstName || ''} ${newData.MiddleName || ''} ${
      newData.LastName || ''
    }`;
    newData.FullName = FullName;
    setPersonData(newData);
  };

  const checkStats = async () => {
    const service = getService('rms-person-merge');
    setLoading(true);
    const sourcePtsPersonID = source.ptsPersonID;
    const targetPtsPersonID = target.ptsPersonID;
    try {
      const result = await service.find({ query: { sourcePtsPersonID, targetPtsPersonID } });
      if (!result || !mountedRef.current) return;
      setError(result.error);
      props.setValidationErrors(Boolean(result.error));
      const stats = [];
      Object.entries(result.data).forEach(([key, val]) => {
        stats.push({ key, val });
      });
      setStats(stats);
    } catch (err) {
      props.handleError(err);
    }
    setLoading(false);
  };

  const renderPerson = () => {
    if (!personData) return '';

    const { PersonID, FullName } = personData;
    return (
      <Paper variant="outlined" className={classes.personDetails}>
        <span>{PersonID}</span> {FullName}
      </Paper>
    );
  };

  const renderDataUpdates = () => {
    if (!stats) return '';
    return (
      <div className={classes.stats}>
        <h5>Records to be updated:</h5>
        <table>
          <tbody>
            {stats.map((row) => (
              <tr key={row.key}>
                <td>{genColHeaderName(row.key)}:</td>
                <td>{row.val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderDeleteSource = () => {
    return (
      <div>
        <FormControlLabel
          control={<Checkbox checked={deleteSource} onChange={(ev, val) => setDeleteSource(val)} />}
          label={`Delete Person - ${source.FullName} ${source.PersonID}`}
        />
      </div>
    );
  };

  const displayErrors = () => {
    return (
      <>
        {Boolean(noFirstName) && (
          <Alert severity="error" className={classes.error}>
            Error, no configuration found for first name: <strong>{personData.FullName}</strong>
          </Alert>
        )}
        {Boolean(error) && (
          <Alert severity="error" className={classes.error}>
            {error}
          </Alert>
        )}
      </>
    );
  };

  return (
    <div>
      <div className={classes.loading}>{loading && <LinearProgress />}</div>
      {displayErrors()}
      {renderPerson()}
      {renderDeleteSource()}
      {renderDataUpdates()}
    </div>
  );
}

export default connect(null, { handleError })(Review);
